@if (isSectionVisible()) {
  <div
    class="form-section"
    [class.form-section--modal]="layout === 'modal'"
    [class.form-section--collapsed]="sectionState.collapsed"
    [class.form-section--required]="!section.collapsible"
    [class.form-section--optional]="section.collapsible"
    [class.form-section--valid]="sectionState.isValid && sectionState.isTouched"
    [class.form-section--invalid]="!sectionState.isValid && sectionState.isTouched"
    [attr.data-section-index]="sectionIndex"
    >
    @if (layout !== 'modal') {
      <div
        class="form-section__header"
        [class.form-section__header--clickable]="section.collapsible"
        (click)="requestToggle()"
        >
        <div class="form-section__header-left">
          <div class="form-section__icon-wrapper">
            <i [class]="'pi ' + (section.icon || 'pi-folder')" class="form-section__icon"></i>
          </div>
          <div class="form-section__header-text">
            <h3 class="form-section__title">
              {{ section.title || 'Sekcja ' + (sectionIndex + 1) }}
              @if (!section.collapsible) {
                <span class="form-section__badge">Wymagane</span>
              }
              @if (section.collapsible) {
                <span class="form-section__badge form-section__badge--optional">
                  Opcjonalne
                </span>
              }
            </h3>
            @if (section.description) {
              <p class="form-section__subtitle">
                {{ section.description }}
              </p>
            }
          </div>
        </div>
        <div class="form-section__header-right">
          @if (sectionState.isTouched) {
            <div class="form-section__status">
              <i
                [class]="sectionState.isValid ? 'pi pi-check-circle' : 'pi pi-exclamation-circle'"
                [class.text-green-500]="sectionState.isValid"
                [class.text-orange-500]="!sectionState.isValid"
              ></i>
              <span class="form-section__status-text">
                {{
                sectionState.isValid
                ? 'Wypełniona'
                : sectionState.validFieldCount + '/' + sectionState.fieldCount
                }}
              </span>
            </div>
          }
          @if (section.collapsible) {
            <button
              type="button"
              class="form-section__toggle"
              [pTooltip]="sectionState.collapsed ? 'Rozwiń sekcję' : 'Zwiń sekcję'"
              >
              <i [class]="sectionState.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></i>
            </button>
          }
        </div>
      </div>
    }
    <div class="form-section__content" [class.form-section__content--hidden]="sectionState.collapsed">
      <div class="grid">
        @for (field of section.fields; track field) {
          @if (isFieldVisible(field)) {
            <div
              [class]="getFieldCssClass(field)"
              [attr.data-field-key]="field.key"
              >
              <app-form-wizard-field-renderer [field]="field" [form]="form" [layout]="layout" />
            </div>
          }
        }
      </div>
    </div>
  </div>
}
